import { Dropdown } from 'react-bootstrap'
import React from 'react';
import { withNamespaces } from 'react-i18next';

class ListPagination extends React.Component{
    render() {
        const { t } = this.props  

        return this.props.itemsPerPage ?
                <Dropdown 
                    className={this.props.class} 
                    style={this.props.style}
                    id={this.props.id}
                >
                    <Dropdown.Toggle 
                        className={this.props.toggleClass} 
                        variant={this.props.toggleVariant} 
                        id={this.props.toggleId} 
                        style={this.props.styleToggle}>
                        {t(this.props.active)}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={this.props.menuClass} id={this.props.menuId} style={this.props.styleMenu}>
                        {this.props.itemsPerPage.map((data, index) => {
                            return <Dropdown.Item 
                                    key={index} 
                                    onClick={() => this.props.onItemsPerPageChange(data, index)}
                                    className={this.props.itemClass}
                                    id={this.props.itemId}
                                    style={this.props.styleItem}
                                >
                                    {t(data)}
                                </Dropdown.Item>
                        })}
                        
                    </Dropdown.Menu>
                </Dropdown>
            : null
    }
}

export default (withNamespaces()(ListPagination));